import "font-awesome/css/font-awesome.css";
import './index.css';
import 'toastr/build/toastr.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import registerServiceWorker from './registerServiceWorker';
import {unregister} from './registerServiceWorker';
import App from './App';
import setAuthorizationToken, { setRefreshToken } from "./utils/setAuthorizationToken";
import UserAuthentication from "./ducks/UserAuthentication";
import Users from "./ducks/Users";
import Permissions from "./ducks/Permissions";
import jwt_decode from "jwt-decode";
import intercept from "./utils/axiosIntercept";
import toastr from "toastr";

toastr.options.toastClass = 'toastr';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root')

const actionCreators = UserAuthentication.creators;
const userAction = Users.creators;
const permissionsActionCreators = Permissions.creators;

intercept(store, actionCreators.logoutUser, history);

if (localStorage.token) {
  try {
    setAuthorizationToken(localStorage.token);
    const user = jwt_decode(localStorage.token);

    store.dispatch(userAction.getUserNotificationsSetting());
    store.dispatch(userAction.subscribeNotifications());
    store.dispatch(actionCreators.setUser(user));
    if (localStorage.refreshToken) {
      setRefreshToken(localStorage.refreshToken);
    }
    if (localStorage.user_id) {
      const user_id = localStorage.user_id;
      store.dispatch(permissionsActionCreators.setUserPermissions(user_id));
    }
    if (localStorage.companyInfo) {

      const { companyId } = JSON.parse(localStorage.companyInfo);
      store.dispatch(permissionsActionCreators.setCompanyFeatures(companyId));

    }
  } catch (err) {
    console.log(err);
    actionCreators.logoutUser();
  }
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
        <App />
    </ConnectedRouter>
  </Provider>,
  rootElement);

//registerServiceWorker();
unregister();

export default history;
